<template>
    <div>
        <v-card class="mx-auto normal-card">
            <div class="data-table-section prev-test-tb">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onSortChange="onSortChange"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.name">
                                <td
                                    class="rescheduletest"
                                    @click="gotoPastTest(item)"
                                >{{item.test_name}}</td>
                                <td class="text-center">{{item.duration}}</td>
                                <td class="text-center">{{item.target_name}}</td>
                                <td class="text-center">{{getFormatedDate(item.date_answered)}}</td>
                                <td class="text-center">{{item.your_marks}}</td>
                                <td class="text-center">{{item.subjects }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div class="btm-test-prev-test">Click on a test name to revisit that test</div>
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left"></div>
            <div class="pull-right">
                <Pagination :currentPage="currentPage" :totalPage="totalPages" :onPageChange="onPageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
    name: "ReadyMadeTest",
    mounted() {        
        this.defaultData();
    },
    data() {
        return {
            headers: [
                { text: "Test Name", value: "alt_test_name" },
                {
                    text: "Duration (Min)",
                    value: "duration",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Target Exam",
                    value: "target_name",
                    class: "text-center",
                    type: "multidropdown",
                    options: [],
                    allText: "All Target Exams"
                },
                {
                    text: "Date Answered",
                    value: "date_answered",
                    class: "text-center"
                },
                {
                    text: "Your Marks",
                    value: "your_marks",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Subjects",
                    value: "subject",
                    class: "text-center",
                    hideSort: true
                }
            ],
            items: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            orderBy: {
                field: "test_name",
                order: "ASC"
            },
            selectedExamTypes: [],
            examTypes: []
        };
    },
    methods: {
        ...mapActions({
            getPastTestList: "testStore/getPastTestList",   
			getTestTarget: "utilStore/getTestTarget",
            getPackages: "userStore/getPackages"
        }),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if(crd) {
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
                this.selectedExamTypes = crd.tabDetails[crd.selectedTab].examTypes;
            }
            this.getPackagesList();
            this.requestGetTestList();		
			this.reqGetTestTargets();

        },

        getFormatedDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        gotoPastTest(item) {
            let test_institute_id = item.test_institute_id; 
            this.$router.push({
                name: "past-test-details",
                params: { test_id: item.id,
                test_institute_id 
                }
            });
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requestGetTestList();
        },
        onSortChange() {
            this.requestGetTestList();
        },
        onHeaderAction(e) {
            if (e.data && e.data.selectedItems) {
                this.selectedExamTypes = e.data.selectedItems;
                let routeName = this.$route.name;
                let crd = this.getCurrentRouteDetails(routeName);
                crd.tabDetails[crd.selectedTab].examTypes = e.data.selectedItems;
                this.setRouteDetails(crd);
                this.onPageChange(1);
            }
        },
        requestGetTestList() {
            let reqData = {
                type: "SELF",
                target_ids: this.selectedExamTypes,
                orderBy: this.orderBy,
                test_name: null,
                pagination: { page: this.currentPage, pageSize: this.pageSize }
            };
            this.$root.showLoader = true;
            this.getPastTestList(reqData)
                .then(response => {
                    if(response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    } 
                    this.$root.showLoader = false;
                    this.items = response.list;
                    this.totalPages = response.pagination.pageCount;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        getPackagesList() {
            this.$root.showLoader = true;
            this.getPackages({})
                .then(response => {
                    this.$root.showLoader = false;
                    this.getExamTypes(response);
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        getExamTypes(response) {
            var examTypes = [];
            response.map(r => {
                if (r.is_purchased) {
                    var typeObj = {
                        text: r.name,
                        checked: this.selectedExamTypes.includes(r.sub_type),
                        value: r.sub_type
                    };
                    examTypes.push(typeObj);
                }
            });
            if (examTypes.length > 0) {
                // this.headers[2].options = examTypes;
            }
        },

        reqGetTestTargets() {
            this.getTestTarget({})
                .then((response) => {
                    this.loading = false;
                 let target = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        c.checked = false;
                        return c;
                    });
					this.headers[2].options = target.filter(c=>c.value != 4);
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
    }
};
</script>